import SubmissionError from '../../../error/SubmissionError'
import http from '../../../utils/http'
import security from '../../../utils/security'
import {
  PAYMENT_CREATE_ERROR,
  PAYMENT_CREATE_LOADING,
  PAYMENT_CREATE_SUCCESS,
  PAYMENT_CREATE_VIOLATIONS,
  PAYMENT_CREATE_RESET
} from './mutation-types'

const state = {
  loading: false,
  error: '',
  created: null,
  violations: {}
}

function error (error) {
  return {type: PAYMENT_CREATE_ERROR, error}
}

function loading (loading) {
  return {type: PAYMENT_CREATE_LOADING, loading}
}

function success (created) {
  return {type: PAYMENT_CREATE_SUCCESS, created}
}

function violations (violations) {
  return {type: PAYMENT_CREATE_VIOLATIONS, violations}
}

function reset () {
  return {type: PAYMENT_CREATE_RESET}
}

const getters = {
  created: state => state.created,
  error: state => state.error,
  loading: state => state.loading,
  violations: state => state.violations,
}

const actions = {
  create ({commit}, values) {
    commit(loading(true))
    commit(violations({}))
    commit(error(null))
    if(values.amount instanceof String){
      values.amount = values.amount.replace(',','.').replace(' ','');
    }
    if(values.amount == ''){
      values.amount = 0
    }
    values.amount = parseFloat(values.amount);

    return http.fetch('/payments', {method: 'POST', body: JSON.stringify(values)})
      .then(response => {
        commit(loading(false))
        return response.json()
      })
      .then(data => {
        commit(success(data))
      })
      .catch(e => {
        commit(loading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors))
          commit(error(e.errors._error))
          return
        }

        commit(error(e.message))
      })
  },
  reset ({commit}) {
    commit(reset())
  }
}

const mutations = {
  [PAYMENT_CREATE_ERROR] (state, payload) {
    state.error = payload.error
  },
  [PAYMENT_CREATE_LOADING] (state, payload) {
    state.loading = payload.loading
  },
  [PAYMENT_CREATE_SUCCESS] (state, payload) {
    state.created = payload.created
  },
  [PAYMENT_CREATE_VIOLATIONS] (state, payload) {
    state.violations = payload.violations
  },
  [PAYMENT_CREATE_RESET] (state) {
    state.loading = false
    state.error = ''
    state.created = null
    state.violations = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/create.js